export const iconWeatherURL = icon => `http://openweathermap.org/img/wn/${icon}@2x.png`;
